module.exports = __webpack_public_path__ + "img/BI_9.f1976b5d.png";